/**
 * «أداء الوحدات» backend error codes. Must match `ErrorCodes` in be/utils/errors.js (LISTING_PERF_xxx).
 * Codes are the contract; config/listingPerformanceLabels.js turns them into words.
 * Pattern reference: web/src/utils/stockErrorCodes.js
 */
export const LISTING_PERF_ERROR_CODES = {
  KEY_NAME_REQUIRED: 'LISTING_PERF_009',
  KEY_NAME_TOO_LONG: 'LISTING_PERF_010',
  KEY_HOLDER_INVALID: 'LISTING_PERF_011',
  KEY_NOT_FOUND: 'LISTING_PERF_012',
  WEEK_INVALID: 'LISTING_PERF_014',
  VIEW_INVALID: 'LISTING_PERF_015',
  OWNER_REQUIRED: 'LISTING_PERF_016',
  OWNER_INVALID: 'LISTING_PERF_017',
  UNIT_NOT_FOUND: 'LISTING_PERF_018',
  CHANGE_DATE_INVALID: 'LISTING_PERF_019',
  CHANGE_TEXT_INVALID: 'LISTING_PERF_020',
  CHANGE_TEXT_TOO_LONG: 'LISTING_PERF_021',
  CHANGE_REQUIRED: 'LISTING_PERF_022',
  CHANGE_NOT_FOUND: 'LISTING_PERF_023',
  CHANGE_PLATFORM_REQUIRED: 'LISTING_PERF_039',
  CHANGE_PLATFORM_INVALID: 'LISTING_PERF_040',
  THRESHOLD_INVALID: 'LISTING_PERF_024',
  THRESHOLD_OUT_OF_RANGE: 'LISTING_PERF_025',
  THRESHOLD_REASON_REQUIRED: 'LISTING_PERF_026',
  THRESHOLD_REASON_TOO_LONG: 'LISTING_PERF_027',
  THRESHOLD_NO_CHANGE: 'LISTING_PERF_028',
  BRIEF_DISABLED: 'LISTING_PERF_029',
  BRIEF_NOT_FOUND: 'LISTING_PERF_030',
  BRIEF_REVIEW_INVALID: 'LISTING_PERF_031',
  BRIEF_REASON_TOO_LONG: 'LISTING_PERF_032',
  BRIEF_NOT_REVIEWABLE: 'LISTING_PERF_033',
  BRIEF_WEEK_NOT_CURRENT: 'LISTING_PERF_034',
  BRIEF_NOT_NEEDED: 'LISTING_PERF_035',
  BRIEF_RERUN_NOT_ALLOWED: 'LISTING_PERF_036',
  BRIEF_CHANGED: 'LISTING_PERF_037',
  BRIEF_ATTEMPTS_USED: 'LISTING_PERF_038',
};
